import { MDBAlert, MDBBtn, MDBIcon, MDBModalFooter, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { deleteFaxGroup } from '../../../apiclients/streamsapi_bridge';

function DeleteFaxGroups(props) {
    const [internalError, setInternalError] = useState(false);
    const { t, i18n } = useTranslation();
    const [isloading, setIsloading] = useState(false);
    const navigate = useNavigate();

    async function removeThisGroup(e) {
        try {
            setInternalError(false);
            setIsloading(true);
            let deleteGrpReponse = await deleteFaxGroup(JSON.parse(sessionStorage.getItem("admin_session")).siteid, props.groupId);
            setTimeout(() => { setIsloading(false) }, 1000);
            let delInfo = await deleteGrpReponse.json();

            if (delInfo.status == 'success') {
                localStorage.setItem("s_message", delInfo.message);
                props.onClose();

                window.location.href = "/faxgroupslandingpage";

            } else {
                localStorage.setItem("f_message", delInfo.message);
                window.location.href = "/faxgroupslandingpage";
            }
        } catch (e) {
            console.log(`Unable to process Request :Internal server Error:!`);
            setInternalError(true);
        }
    }
    return (
        <>
            {internalError && (<MDBAlert
                open
                className="alert-center"
                color="danger"
                autohide
                position="bottom-right"
                delay={5000}
            >Internal Server Error</MDBAlert>)}
            <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                <span>{t("RemoveFaxGrouptxt")}</span>
            </div>

            <MDBModalFooter className='p-0 mt-3 pt-2'>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => removeThisGroup(e)}>{t("remove")}</MDBBtn>
            </MDBModalFooter>
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
        </>
    );
}

export default DeleteFaxGroups
